import API from '../util/api';
import { store } from '../redux/store'

const token = store.getState().auth.authToken;

// login
export const login = async (formData) => {
    try {
        let headers = {};
        const response = await API.post(`/api/login`, formData, { headers: headers });
        if (response.status === 200) {
            return response.data
        }
    } catch (errors) {
        throw (errors)
    }
}

// Logout
export const logoutSession = async (formData, token) => {
    const { data } = await API.post("/api/logout", formData, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return data;
}

// Forgot Password
export const forgotPassword = async (formData) => {
    try {
        let headers = {};
        const response = await API.post(`/api/forgotpassword`, formData, { headers: headers });
        if (response.status === 200) {
            return response.data
        }
    } catch (errors) {
        throw (errors)
    }
}

// Set Password
export const setPassword = async (formData) => {
    try {
        let headers = {};
        const response = await API.post(`/api/setpassword`, formData, { headers: headers });
        if (response.status === 200) {
            return response.data
        }
    } catch (errors) {
        throw (errors)
    }
}

// Change Password (User)
export const changePassword = async (formData) => {
    try {
        let headers = {};
        headers.Authorization = `Bearer ${token}`
        const response = await API.post(`api/changepassword`, formData, { headers: headers });
        if (response.status === 200) {
            return response.data
        }
    } catch (errors) {
        throw (errors)
    }
}

// Verify Captcha Token
export const verifyCaptchaToken = async (formData) => {
    try {
        let headers = {};
        const response = await API.post(`/api/verify_captcha`, formData, { headers: headers });
        if (response.status === 200) {
            return response.data
        }
    } catch (errors) {
        throw (errors)
    }
}

// Get Logged In User Info
export const getLoggedInUserInfo = async (token1) => {
    try {
        let headers = {};
        headers.Authorization = `Bearer ${token1}`
        const response = await API.get(`/api/get_logged_in_user_info`, { headers: headers });
        if (response.status === 200) {
            return response.data
        }
    } catch (errors) {
        throw (errors)
    }
}